import Card from '@components/Card';
import Text from '@components/Text';
import colors from '@constants/colors';
import { InquiryRow } from '@models/inquiry';
import { Link } from '@router/Link';
import dayjs from 'dayjs';

import InquiryBadge from '../InquiryBadge';
import styles from './styles.module.scss';

interface Props {
    inquiry: InquiryRow;
}

function InquiryItem({ inquiry }:Props) {
  const {
    status, createdAt, title, inquiryId, content,
  } = inquiry;
  return (
        <Link activityParams={{ inquiryId }}
              activityName='InquiryLogActivity'
              className={styles.wrapper} >
            <Card>
                <Card.Body>
                    <InquiryBadge status={status} />
                    <Text size='xl' fontWeight='bold' className={styles.title}>
                        {title}
                    </Text>
                    <Text color={colors.gray7} ellipsis>
                        {content}
                    </Text>
                </Card.Body>
                <Card.Footer>
                    <Text color={colors.gray6}>
                        {dayjs(createdAt).format('YYYY.MM.DD')}
                    </Text>
                </Card.Footer>
            </Card>
        </Link>
  );
}

export default InquiryItem;
